<template>
  <div class="main-grid">
    <ms-grid
      :data="items"
      :columns="columns"
      :options="options"
      :pager="pager"
      :add-register="profile.role !== 'gerente_dealer'"
      @notFoundItem="newMachinerie"
    />
    <create-machinerie
      v-if="showTractorPanel"
      :is-edit="isEdit"
      :old="oldMachinerie"
      @closeEdicionMachinerie="closeEdit"/>
  </div>
</template>

<script>
import CreateMachinerie from '@/views/app/machineries/machineries-create-view'
import MsGrid from '@/modules/grid/ms-grid'
import CustomersGuards from '@/guards/customers.guards'

export default {
  name: 'CustomersTractorsTable',
  components: {
    MsGrid,
    CreateMachinerie
  },
  data () {
    return {
      columns: [
        {
          property: 'model',
          label: 'Modelo',
          align: 'center'
        },
        {
          property: 'brand',
          label: 'Marca',
          align: 'center'
        },
        {
          property: 'year',
          label: 'Año',
          align: 'center'
        },
        {
          property: 'type',
          label: 'Tipo',
          align: 'center'
        }
      ],
      searchParams: {params: {}},
      isEdit: false,
      oldMachinerie: null
    }
  },
  computed: {
    items () {
      return this.$store.getters['machineries/items']
    },
    pager () {
      return this.$store.getters['machineries/pagination']
    },
    profile () {
      return this.$store.getters['profile/me']
    },
    showTractorPanel () {
      return this.$store.getters['app/showTractorPanel']
    },
    options () {
      let actions = this.profile.role !== 'gerente_dealer'
        ? [
          {
            label: 'Editar',
            icon: 'icon-edit',
            onClick: (row) => {
              this.onEdit(row)
            }
          }
        ]
        : []
      return {
        selectable: false,
        actions: actions
      }
    }
  },
  methods: {
    newMachinerie () {
      this.$store.dispatch('app/toggleTractorPanel')
    },
    onEdit (val) {
      this.oldMachinerie = val
      this.isEdit = true
      this.$store.dispatch('app/toggleTractorPanel')
    },
    closeEdit (val) {
      this.isEdit = val
    }
  },
  beforeRouteUpdate: CustomersGuards.onGetCustomer
}
</script>



// WEBPACK FOOTER //
// src/modules/customers/customers-tractors-table.vue